const findAncestor = (el, cls) => {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
};

const renderOverlappingSection = () => {
    const hasOverlappingColumns = document.querySelectorAll('.row.has-overlapping-col');

    if(hasOverlappingColumns){
        for(let i=0, l=hasOverlappingColumns.length; i <l; i++){
            const sectionShape = hasOverlappingColumns[i].querySelector('.section-shape');

            if(sectionShape){
                hasOverlappingColumns[i].insertBefore(sectionShape, hasOverlappingColumns[i].lastElementChild);
            }
        }
    }
};

const renderFeaturedTilesSection = () => {
    const featuredTiles = document.querySelectorAll('.featured-tile');

    if(!featuredTiles)
        return false;

    for (let index = 0; index < featuredTiles.length; index++) {
        let tile = featuredTiles[index];
        let row = findAncestor(tile, 'row');

        if(row)
        row.classList.add('tiles-list');
    }
};

const renderFilterSection = () => {
    const filterSection = document.querySelector('.feature-listing .listing--pagination-card') || document.querySelector('.feature-listing__wrapper .sentence-dropdown');

    if(!filterSection)
        return false;

    const section = findAncestor(filterSection, 'section'),
        sectionShape = section.nextElementSibling;

    if(section)
        section.classList.add('has-filters');
    
    if(sectionShape && sectionShape.classList.contains('section-shape')){
        $(section).append(sectionShape);
    }
};

const renderFeaturedListSection = () => {
    const listingRow = document.querySelectorAll('.listing__row');

    if(!listingRow)
        return false;

    for(let i=0, l=listingRow.length; i <l; i++){

        const section = findAncestor(listingRow[i], 'detail'),
        row = section.querySelector('.row'),
        themeClass = listingRow[i].querySelector('.card__date') ? 'theme-teal' : 'theme-darkorange';
    
        if(row)
            row.classList.add('has-three-items', themeClass);
    }

};

const renderTeamTilesSection = () => {
    const teamTile = document.querySelector('.tile__info');

    if(!teamTile)
        return false;

    const row = findAncestor(teamTile, 'row');

    if(row)
        row.classList.add('tiles-list', 'has-xl-gutter');
};

const renderSectionWithoutSpacing = () => {
    const rowNoSpacing = document.querySelectorAll('.twelve-no-spacing');

    if(!rowNoSpacing)
        return false;

    for(let i=0, l=rowNoSpacing.length; i <l; i++){
        const section = findAncestor(rowNoSpacing[i], 'detail');

        if(section)
            section.classList.add('no-spacing');
    }
}

export { 
    renderOverlappingSection, 
    renderFeaturedTilesSection,
    renderFeaturedListSection,
    renderFilterSection,
    renderTeamTilesSection,
    renderSectionWithoutSpacing
};